import { Header } from "@/components/Header";
import { ProductionView } from "@/components/production/ProductionView";
import { MeasurementPhotos } from "@/components/production/MeasurementPhotos";
import { WorkOrders } from "@/components/production/WorkOrders";
import { Procurement } from "@/components/production/Procurement";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const triggerCls = "data-[state=active]:bg-amber-400 data-[state=active]:text-[#0D1117] font-semibold uppercase text-xs tracking-wider";

export default function Production() {
  return (
    <div className="min-h-screen relative z-10">
      <Header />
      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
        <div className="rise">
          <p className="font-mono text-xs text-amber-400 tracking-widest uppercase">Panel produkcji</p>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight">Produkcja</h1>
        </div>
        <Tabs defaultValue="queue">
          <TabsList data-testid="prod-main-tabs" className="sticky top-16 z-30 bg-card border border-border flex-wrap h-auto justify-start gap-1 p-1">
            <TabsTrigger data-testid="prod-main-tab-queue" value="queue" className={triggerCls}>Kolejka produkcji</TabsTrigger>
            <TabsTrigger data-testid="prod-main-tab-measure" value="measure" className={triggerCls}>Zdjęcia pomiarowe</TabsTrigger>
            <TabsTrigger data-testid="prod-main-tab-orders" value="orders" className={triggerCls}>Zlecenia</TabsTrigger>
            <TabsTrigger data-testid="prod-main-tab-procurement" value="procurement" className={triggerCls}>Zaopatrzenie</TabsTrigger>
          </TabsList>
          <TabsContent value="queue" className="mt-5"><ProductionView /></TabsContent>
          <TabsContent value="measure" className="mt-5"><MeasurementPhotos /></TabsContent>
          <TabsContent value="orders" className="mt-5"><WorkOrders /></TabsContent>
          <TabsContent value="procurement" className="mt-5"><Procurement /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
